require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[23],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(246);


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ExpandableTile = _interopRequireDefault(__webpack_require__(247));

exports["default"] = _ExpandableTile["default"];
exports.ExpandableTile = _ExpandableTile["default"];

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

var _lodash = __webpack_require__(20);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */
var BaPropTypes = _utils.propsUtils.BaPropTypes;

var ExpandableTile = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ExpandableTile, _Component);

  function ExpandableTile() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ExpandableTile.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        maxWidth = _this$props.maxWidth,
        label = _this$props.label,
        children = _this$props.children,
        labelStyle = _this$props.labelStyle,
        labelClassName = _this$props.labelClassName,
        initialExpanded = _this$props.initialExpanded,
        expanded = _this$props.expanded,
        onChange = _this$props.onChange,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["maxWidth", "label", "children", "labelStyle", "labelClassName", "initialExpanded", "expanded", "onChange"]);
    var mappedProps = {
      expanded: expanded != null ? expanded : initialExpanded,
      handleClick: onChange
    };
    var passThroughProps = (0, _lodash.omit)(others, 'pinMode');
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.ExpandableTile, (0, _extends2["default"])({
      maxWidth: maxWidth
    }, mappedProps, passThroughProps), /*#__PURE__*/_react["default"].createElement(_baUiCarbon.TileAboveTheFoldContent, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: labelClassName,
      style: labelStyle
    }, label)), /*#__PURE__*/_react["default"].createElement(_baUiCarbon.TileBelowTheFoldContent, null, /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, children)));
  };

  return ExpandableTile;
}(_react.Component);

exports["default"] = ExpandableTile;
(0, _defineProperty2["default"])(ExpandableTile, "propTypes", {
  /** Data passed to the above the fold content
   *  Legacy tooltip prop will map to TileAboveTheFoldContent
   */
  label: _propTypes["default"].node,

  /**
   * Carbon The child nodes.
   * Or legacy tooltip child nodes will map to TileBelowTheFoldContent
   * Data passed to the below the fold content
   */
  children: _propTypes["default"].node,

  /**
   * The CSS class names.
   */
  className: _propTypes["default"].string,

  /**
   * Legacy toolkit prop will map to expanded
   * Specifies whether the tile is initially expanded or not */
  initialExpanded: _propTypes["default"].bool,

  /**
   * `true` if the tile is expanded.
   */
  expanded: _propTypes["default"].bool,

  /**
   * optional handler to decide whether to ignore a click. returns false if click should be ignored
   */
  onBeforeClick: _propTypes["default"].func,

  /**
   * The `tabindex` attribute.
   */
  tabIndex: _propTypes["default"].number,

  /**
   * The description of the "collapsed" icon that can be read by screen readers.
   */
  tileCollapsedIconText: _propTypes["default"].string,

  /**
   * The description of the "expanded" icon that can be read by screen readers.
   */
  tileExpandedIconText: _propTypes["default"].string,

  /**
   * An ID that can be provided to aria-labelledby
   */
  id: _propTypes["default"].string,

  /**
   * `true` to use the light version. For use on $ui-01 backgrounds only.
   * Don't use this to make tile background color same as container background color.
   */
  light: _propTypes["default"].bool,

  /** Legacy toolkit prop
   * Specifies the maximum width of the ExpandableTile
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Legacty toolkit prop, will pass to TileAboveTheFoldContent
   * Styles for the TileAboveTheFoldContent
   */
  labelStyle: _propTypes["default"].object,

  /**
   * Legacty toolkit prop, will pass to TileAboveTheFoldContent
   * The CSS class names for the TileAboveTheFoldContent
   */
  labelClassName: _propTypes["default"].string,

  /** Legacty toolkit prop, will pass to CarbonExpandableTile
   * Styles for the CarbonExpandableTile
   */
  style: _propTypes["default"].object,

  /**
   * Legacy toolkit prop will map to handleClick
   * Callback function when the item is toggled
   */
  onChange: _propTypes["default"].func,
  // deprecated prop
  // eslint-disable-next-line react/no-unused-prop-types
  pinMode: BaPropTypes.deprecatedByCarbon(_baUiCarbon.ExpandableTile)
});
(0, _defineProperty2["default"])(ExpandableTile, "defaultProps", {
  maxWidth: 'max-content',
  labelClassName: ''
});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ })

},[[245,0]]]);
});